import "./patientview.css";
import React from "react";
import { useSelector } from "react-redux";
import { connect } from "react-redux";
import { Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import { formatDate, parseDate } from "../../utils/parsers";
import { classifyBySignedDays } from "../../utils/survClassifier";
import { useSurveyMode } from "../../contexts/SurveyModeProvider";

class PatientSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getSurvClassification = () => {
    // Back end provides signed days in pt.day_adm_first_positive:
    //   ≥0 → currently admitted (days since admission)
    //   <0 → days since last discharge (we set negative in backend)
    const day = this.props.patient?.pt?.day_adm_first_positive;
    console.log(this.props.patient)
    return classifyBySignedDays(day);
  };

  first_pos_txt = function () {
    if (
      this.props.patient.pt.day_adm_first_positive &&
      this.props.patient.pt.day_adm_first_positive >= 0
    ) {
      return (
        <>
          {" (Day " +
            (this.props.patient.pt.day_adm_first_positive + 1) +
            " of this admission)"}
        </>
      );
    }
    if (
      this.props.patient.pt.day_adm_first_positive &&
      this.props.patient.pt.day_adm_first_positive < 0
    ) {
      return (
        <>
          {" (" +
            -1 * this.props.patient.pt.day_adm_first_positive +
            " day(s) since last discharged)"}
        </>
      );
    } else {
      return <>{""}</>;
    }
  };

  get_current_location = () => {
    if (this.props.patient.pt.most_recent_ward) {
      return this.props.patient.pt.most_recent_ward;
    } else {
      return "Unknown";
    }
  };

  render() {
    const surv = this.getSurvClassification(); // { short, long, color }
    const showSurvBadge =
      (!this.props.debug_mode && this.props.survey_mode >= 2) ||
      (this.props.debug_mode && this.props.debug_survey_mode >= 2);

    return (
      <div
        className="container-fluid"
        style={{
          maxWidth: "1600px",
          marginLeft: 0,
          marginRight: "auto",
          height: "auto",
          minHeight: "80px",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <div
          className="row"
          style={{
            paddingBottom: 10,
            paddingTop: 0,
            paddingLeft: 40,
            paddingRight: 10,
            fontSize: "14px",
          }}
        >
          {/* Patient info */}
          <div
            className="col-md-3"
            style={{
              borderRight: "1px solid #ccc",
              paddingRight: "30px",
              marginRight: "20px",
              marginTop: "-5px",
            }}
          >
            <span style={{ fontWeight: 500, fontSize: "20px" }}>
              {this.props.patient.pt.name}
            </span>
            <span style={{ fontWeight: 400, fontSize: "16px" }}>
              &nbsp;({this.props.patient.pt.hospital_number})
            </span>
            <div>
              <strong>
                Age{" "}
                {Math.floor(
                  (parseDate(this.props.patient.pt.first_positive) -
                    parseDate(this.props.patient.pt.dob)) /
                    3.154e10
                )}
                , {this.props.patient.pt.gender}
              </strong>
            </div>
            <div>
              <strong>Born:</strong>{" "}
              {formatDate(parseDate(this.props.patient.pt.dob))}
            </div>
          </div>

          {/* If inpatient */}
          {this.props.patient.pt.ward_first_positive ? (
            <div
              className="col-md-4"
              style={{
                borderRight: "1px solid #ccc",
                paddingRight: "30px",
                marginRight: "20px",
              }}
            >
              <div>
                <Badge
                  pill
                  bg=""
                  style={{ fontSize: "0.85rem", marginRight: "3px", pointerEvents: "none", backgroundColor: "#1ABC9C" }}
                >
                  Inpatient
                </Badge>
                {showSurvBadge && (
                  <OverlayTrigger
                    placement="bottom"
                    container={document.body}
                    flip={false}
                    popperConfig={{
                      modifiers: [{ name: 'flip', enabled: false }]
                    }}
                    overlay={
                    <Tooltip id="surv-classifier-tooltip">
                      {surv.long}
                    </Tooltip>
                    }
                  >
                    <Badge
                    pill
                    bg=""
                    style={{
                      fontSize: "0.85rem",
                      marginRight: "3px",
                      backgroundColor: surv.color,
                      color: "#fff",
                      cursor: "pointer"
                    }}
                    onMouseEnter={e => (e.target.style.color = "#fff")}
                    onMouseLeave={e => (e.target.style.color = "#fff")}
                    >
                    {surv.short}
                    </Badge>
                  </OverlayTrigger>
                )}
                </div>
                <div>
                <strong>Admitted:</strong>{" "}
                {formatDate(parseDate(this.props.patient.pt.adm_start))}
                </div>
                <div>
                <strong>Current Location:</strong>{" "}
                {this.get_current_location()}
                </div>
              </div>
                      ) : (
            // If outpatient
            <div
              className="col-md-4"
              style={{
                borderRight: "1px solid #ccc",
                paddingRight: "30px",
                marginRight: "20px",
              }}
            >
              <div>
                <Badge
                  pill
                  bg=""
                  style={{ fontSize: "0.85rem", marginRight: "3px", pointerEvents: "none", backgroundColor: "#9B59B6" }}
                >
                  Outpatient
                </Badge>

                {/* Wrap the classification badge in an OverlayTrigger */}
                {showSurvBadge && (
                  <OverlayTrigger
                    placement="bottom"
                    container={document.body}
                    flip={false}
                    popperConfig={{
                      modifiers: [{ name: 'flip', enabled: false }]
                    }}
                    overlay={
                      <Tooltip id="surv-classifier-tooltip">
                        {surv.long}
                      </Tooltip>
                    }
                  >
                    <Badge
                      pill
                      bg=""
                      style={{ fontSize:"0.85rem", marginRight:"3px", backgroundColor:surv.color, color:"#fff" }}
                    >
                      {surv.short}
                    </Badge>
                  </OverlayTrigger>
                )}
              </div>

              {this.props.patient.pt.most_recent_adm_start &&
              this.props.patient.pt.most_recent_adm_end ? (
                <div>
                  <strong>Last Admitted: </strong>
                  {formatDate(parseDate(this.props.patient.pt.most_recent_adm_start))} –{" "}
                  {formatDate(parseDate(this.props.patient.pt.most_recent_adm_end))}
                </div>
              ) : (
                <div>
                  <strong>Last Admitted: </strong> No hospital admission in the
                  last 180 days
                </div>
              )}
              <div>
                <strong>Last Location:</strong> {this.get_current_location()}
              </div>
            </div>
          )}

          {/* C. diff info */}
          <div className="col-md-4">
            <div>
              <strong>Positive for &nbsp;</strong>
              <Badge pill bg="" style={{ fontSize: "0.85rem", pointerEvents: "none", backgroundColor: "#E74C3C"}}>
                <i>Clostridiodes difficile</i> Toxin
              </Badge>
            </div>
            <div>
              <strong>Test Date:</strong>{" "}
              {formatDate(parseDate(this.props.patient.pt.first_positive))}{" "}
              {this.first_pos_txt()}
            </div>
            <div></div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    patient: state.patient.patient,
    ptId: state.patient.micro_id,
  };
}

const ConnectedPatientSummary = connect(mapStateToProps)(PatientSummary);

function PatientSummaryWithSurvey(props) {
  const survey = useSelector((state) => state.survey);
  const activeCase = useSelector((state) => state.survey.activeCase);
  const debug_survey_mode = useSelector((state) => state.survey.debug_survey_mode);
  const survey_mode = survey.surveyHistory[activeCase?.micro_id]?.mode || 0;
  const { debug_mode } = useSurveyMode();

  return (
    <ConnectedPatientSummary
      {...props}
      survey_mode={survey_mode}
      debug_mode={debug_mode}
      debug_survey_mode={debug_survey_mode}
    />
  );
}

export default PatientSummaryWithSurvey;
